export enum TipoDocumento {
  REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA = "Requerimento Assinado e Reconhecido Firma",
  COPIA_CRLV = "Cópia da CRLV",
  APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA = "Apólice de Seguro Assinada e Carimbada pela Seguradora",
  LAUDO_TECNICO = "Laudo Técnico",
  ART = "ART",
  VISTORIA = "Vistoria"
}
